var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 12.3334H13",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.33328C10.2652 1.06806 10.6249 0.919067 11 0.919067C11.1857 0.919067 11.3696 0.955647 11.5412 1.02672C11.7128 1.09779 11.8687 1.20196 12 1.33328C12.1313 1.4646 12.2355 1.6205 12.3066 1.79208C12.3776 1.96366 12.4142 2.14756 12.4142 2.33328C12.4142 2.519 12.3776 2.7029 12.3066 2.87448C12.2355 3.04606 12.1313 3.20196 12 3.33328L3.66667 11.6666L1 12.3333L1.66667 9.66661L10 1.33328Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditEmailIcon);
export default __webpack_public_path__ + "static/media/edit-email-icon.10c64ed0634d75b52fc7cd2786650c6a.svg";
export { ForwardRef as ReactComponent };